import type { ShortTermViewFeedName } from '@zcode/state-type'

export const AIMCO = 'aimco'
export const APT_FINDER = 'apt_finder'
export const APTS_COM = 'apts_com'
export const BLUEGROUND = 'blueground'
export const BOOKINGDOTCOM = 'bookingdotcom'
export const BOZZUTO = 'bozzuto_mits41'
export const BUNGALOW = 'bungalow'
export const CHIMLS = 'chimls'
export const EQUITY = 'equity'
export const ESSEX = 'essex'
export const EVOLVE = 'evolve'
export const FOR_RENT = 'for_rent'
export const HOT_PADS = 'hot_pads'
export const JUNE_HOMES = 'june_homes'
export const LISTHUB = 'listhub'
export const LLWS = 'llws'
export const MNP = 'mnp'
export const NESTPICK = 'nestpick'
export const NESTPICK_HIGH = 'nestpick_high'
export const NRT = 'nrt'
export const RENT_BOARD = 'rent_board'
export const RENT_LINX = 'rent_linx'
export const RENT_LINX_PLUS = 'rent_linx_plus'
export const RENT_SENTINEL = 'rent_sentinel'
export const RENTALS_UNITED = 'rentals_united'
export const RENTPATH = 'rentpath'
export const RENTPATH_TRULIA = 'rentpath_trulia'
export const RHP = 'rhp'
export const SUBLET_COM = 'sublet_com'
export const TOWN_RESIDENTIAL = 'town_residential'
export const VRBO = 'vrbo'
export const WSR = 'wsr'
export const YARDI = 'yardi'

export const sourceNameByFeed = {
  [BOOKINGDOTCOM]: 'Booking.com',
  [EVOLVE]: 'Evolve',
  [JUNE_HOMES]: 'June Homes',
  [NESTPICK]: 'Nestpick',
  [NESTPICK_HIGH]: 'Nestpick',
  [RENTALS_UNITED]: 'Rentals United',
  [VRBO]: 'Vrbo',
} as const

export const bookingProviders = [
  BOOKINGDOTCOM,
  EVOLVE,
  JUNE_HOMES,
  RENTALS_UNITED,
  VRBO,
] as const satisfies readonly ShortTermViewFeedName[]
const _bookingProvidersWeForgotToInclude: Exclude<
  ShortTermViewFeedName,
  (typeof bookingProviders)[number]
> = 1 as never
_bookingProvidersWeForgotToInclude satisfies never

export const BOZZUTO_ATTRIBUTION_BUILDING_IDS = [
  828047, 828050, 828051, 828052, 828053, 828054,
] as const

export const DOMINIUM_BROKERAGE_ID = 9097
